import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BackgroundComponent } from './backround.component';

const routes: Routes = [
  {
    path: 'modals',
    component: BackgroundComponent,
    children: [
      {
        path: 'reset-password',
        loadChildren: () => import('./reset-password/reset-password.module').then((m) => m.ResetPasswordModule),
      },
      { path: '', redirectTo: 'reset-password', pathMatch: 'full' },
      { path: '**', redirectTo: 'reset-password' },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ModalsRoutingModule {}
